import { useCallback, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { resolveDefaultRosterSectionId } from "../resolveAccessibleSections";
import { useRosterAccessibleSectionsValue } from "../RosterAccessibleSectionsProvider";

export function useRosterDashboardSectionSelection() {
  const [searchParams, setSearchParams] = useSearchParams();
  const preferredSectionId = searchParams.get("sectionId");
  const { sections, defaultSectionId, canViewRosterActivity, loading } =
    useRosterAccessibleSectionsValue(preferredSectionId);

  const sectionId = useMemo(
    () => resolveDefaultRosterSectionId(sections, preferredSectionId ?? defaultSectionId),
    [sections, preferredSectionId, defaultSectionId]
  );

  const setSectionId = useCallback(
    (nextSectionId: string) => {
      setSearchParams({ sectionId: nextSectionId }, { replace: true });
    },
    [setSearchParams]
  );

  useEffect(() => {
    if (loading || !sectionId || preferredSectionId === sectionId) {
      return;
    }

    setSearchParams({ sectionId }, { replace: true });
  }, [loading, preferredSectionId, sectionId, setSearchParams]);

  return {
    sections,
    sectionId,
    setSectionId,
    canViewRosterActivity,
    loading
  };
}
